import { useMemo } from 'react';
import {
  getTenantConfiguration,
  type TenantConfiguration,
} from '@/constants/tenantConfiguration';
import { useTenantID } from '@/hooks/useTenantID';

export const useTenantConfiguration = (): TenantConfiguration => {
  const tenantId = useTenantID();
  return useMemo(() => getTenantConfiguration(tenantId), [tenantId]);
};
